import React, { useState, useEffect } from "react";
import {
  Typography,
  TextField,
  MenuItem,
  Box,
  Button,
  Switch,
  Collapse,
  ListItem,
  List,
  ListItemText,
  ListItemIcon,
  CircularProgress,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { ExpandLess, ExpandMore } from "@material-ui/icons";
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
import axios from "axios";
import { appUrl } from "../../../../../../utils/config";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiSwitch-switchBase.Mui-checked": {
      color: "#1890ff",
    },
    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
      backgroundColor: "#1890ff",
    },
  },
  container: {
    display: "flex",
    flexDirection: "column",
    minHeight: "90%",
    marginTop: theme.spacing(2),
  },
  content: {
    flexGrow: 1,
  },
  heading: {
    fontSize: "14px",
    fontWeight: 500,
    marginBottom: theme.spacing(1),
  },
  textField: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  resetText: {
    color: "#286ACF",
    fontSize: "14px",
    fontWeight: 500,
    cursor: "pointer",
    textDecoration: "underline",
    marginBottom: theme.spacing(1),
  },
  listContainer: {
    border: "1px solid #ccc",
    padding: 0,
  },
  screen: {
    padding: theme.spacing(1),
    backgroundColor: "#f5f5f5",
  },
  feature: {
    padding: theme.spacing(1),
    borderTop: "1px solid #ccc",
  },
  buttonContainer: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "space-between",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
    textTransform: "none",
  },
}));

// const initialScreensAndFeaturesData = [
//   {
//     screen_id: 1,
//     screen_name: "GRN Receipts Dashboard",
//     screen_access: true,
//     features: [
//       { feature_id: 1, feature: "Export to Excel", feature_access: true },
//       { feature_id: 2, feature: "Approve GR", feature_access: true },
//       { feature_id: 3, feature: "View GR Details", feature_access: true },
//       { feature_id: 4, feature: "Download GR Files", feature_access: false },
//     ],
//   },
//   {
//     screen_id: 2,
//     screen_name: "Schedule Agreements",
//     screen_access: false,
//     features: [
//       { feature_id: 5, feature: "View Schedule", feature_access: false },
//     ],
//   },
//   {
//     screen_id: 3,
//     screen_name: "Delivery Schedule Details",
//     screen_access: true,
//     features: [
//       {
//         feature_id: 6,
//         feature: "Edit Delivery Schedule",
//         feature_access: true,
//       },
//       {
//         feature_id: 7,
//         feature: "Delete Delivery Schedule",
//         feature_access: false,
//       },
//     ],
//   },
//   {
//     screen_id: 4,
//     screen_name: "FG Batch",
//     screen_access: true,
//     features: [
//       { feature_id: 8, feature: "View FG Batch Details", feature_access: true },
//     ],
//   },
// ];

export default function AccessPermission({
  setShowComponent,
  departmentAPI,
  roleInfo,
  setCount,
}) {
  const classes = useStyles();
  const [expandedSections, setExpandedSections] = useState({});
  const [selectedRole, setSelectedRole] = useState("");
  const [screensAndFeatures, setScreensAndFeatures] = useState([]);
  const [apiData, setApiData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [rolesData, setRolesData] = useState([]);

  useEffect(() => {
    if (selectedRole) {
      setError(null);
      setLoading(true);
      axios
        .get(
          `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType
          }/${localStorage.roleName
          }/fetchScreensAndFeatures/${selectedRole}/${0}`
        )
        .then((res) => {
          if (res.data.status) {
            // throw new Error("Error fetching permissions");
            setApiData(res.data.data.screensAndFeatures);
            setScreensAndFeatures(res.data.data.screensAndFeatures);
          } else {
            throw new Error("Error fetching permissions");
          }
        })
        .catch((err) => {
          setError(err.message || "Error fetching permissions");
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [selectedRole]);

  useEffect(() => {
    // if (selectedRole) {
    setError(null);
    setLoading(true);
    axios
      .get(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType
        }/${localStorage.roleName}/fetchAllRoles/${0}/${1}/${200}`
      )
      .then((res) => {
        if (res.data.status) {
          // throw new Error("Error fetching permissions");
          setRolesData(res.data.data.rolesAndAccessDashboard);
        } else {
          throw new Error("Error fetching Roles Dropdown");
        }
      })
      .catch((err) => {
        console.error("Fetch Error ", err.message);
        // setError(err.message || "Error fetching permissions");
      })
      .finally(() => {
        setLoading(false);
      });
    // }
  }, []);

  const existingRoles = React.useMemo(() => {
    const departmentDetails = departmentAPI?.departmentDetailsList?.find(
      (dept) => dept.departmentName === roleInfo.department
    );

    if (departmentDetails) {
      return departmentDetails?.rolesList?.map((role) => ({
        label: `${departmentDetails.departmentName} - ${role.role_name}`,
        value: role.collaborator_role_id,
      }));
    }
    return [];
  }, [roleInfo.department, departmentAPI]);

  const availableRoles = React.useMemo(() => {
    if (existingRoles.length === 0) {
      return rolesData.map((role) => ({
        label: `${role.departmentName} - ${role.role_name}`,
        value: role.collaborator_role_id,
      }));
    }
    return existingRoles;
  }, [existingRoles, rolesData]);

  const handleRoleChange = (e) => {
    setSelectedRole(e.target.value);
    if (e.target.value === "") {
      setApiData([]);
      setScreensAndFeatures([]);
    }
  };
  const handleExpand = (screenId) => {
    setExpandedSections((prev) => ({
      ...prev,
      [screenId]: !prev[screenId],
    }));
  };

  const handleToggleScreen = (screenId) => {
    setScreensAndFeatures((prev) =>
      prev.map((screen) =>
        screen.screen_id === screenId
          ? {
            ...screen,
            screen_access: !screen.screen_access,
            features: screen.screen_access
              ? screen.features.map((feature) => ({
                ...feature,
                feature_access: false, // Turn off all features if screen is turned off
              }))
              : screen.features, // Leave features unchanged when turning on
          }
          : screen
      )
    );
  };

  const handleToggleFeature = (screenId, featureId) => {
    setScreensAndFeatures((prev) =>
      prev.map((screen) =>
        screen.screen_id === screenId
          ? {
            ...screen,
            features: screen.features.map((feature) =>
              feature.feature_id === featureId
                ? { ...feature, feature_access: !feature.feature_access }
                : feature
            ),
          }
          : screen
      )
    );
  };

  const isPermissionsChanged = () => {
    return JSON.stringify(screensAndFeatures) !== JSON.stringify(apiData);
  };

  const addCollaboratorRole = (requestObject) => {
    setError(null);
    setLoading(true);

    axios
      .post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/addCollaboratorRoles`,
        requestObject
      )
      .then((res) => {
        // throw new Error("Mock Error");
        if (res.data) {
          setShowComponent("SuccessScreen");
        }
      })
      .catch((err) => {
        setError(err.message);
      })
      .finally(() => setLoading(false));
  };
  const handleBack = () => setShowComponent("RoleDetails");
  const handleReset = () => {
    // console.log("Reset button clicked");
    setScreensAndFeatures(apiData);
  };
  const handleCreate = () => {
    // Find the departmentID by comparing departmentName with roleInfo.department
    const departmentDetails = departmentAPI?.departmentDetailsList?.find(
      (dept) => dept.departmentName === roleInfo.department
    );
    const departmentID = departmentDetails?.departmentID || null;

    if (!departmentID) {
      setError("Invalid department or department not found.");
      return;
    }
    // Build the collaboratorRolesList object
    const collaboratorRolesList = [
      {
        collaboratorRoleDetails: {
          role_description: roleInfo.roleDescription,
          role_name: roleInfo.roleName,
          departmentID,
          roleType: roleInfo.roleType,
          // roleType: "New",
        },
        screensAndFeatures: screensAndFeatures
          .filter((screen) => screen.screen_access) // Only include screens with access
          .map((screen) => ({
            screen_id: screen.screen_id,
            screen_name: screen.screen_name,
            screen_access: screen.screen_access,
            features: screen.features
              .filter((feature) => feature.feature_access) // Only include features with access
              .map((feature) => ({
                feature_id: feature.feature_id,
                feature: feature.feature,
                feature_access: feature.feature_access,
              })),
          })),
      },
    ];
    const requestObject = { collaboratorRolesList };

    if (!isPermissionsChanged()) {
      setShowComponent("NoChangeError");
    } else {
      calculateCount();
      addCollaboratorRole(requestObject);
    }
  };
  //calculate count of enabled and disabled features and update count state
  const calculateCount = () => {
    // console.log("Screen and features ", screensAndFeatures);
    let enabledCount = 0;
    let disabledCount = 0;

    screensAndFeatures.forEach((screen) => {
      if (screen.screen_access) {
        screen.features.forEach((feature) => {
          if (feature.feature_access) {
            enabledCount++;
          } else {
            disabledCount++;
          }
        });
      } else {
        // if screen is disabled then all features will be disabled
        disabledCount += screen.features.length;
      }
    });

    setCount({ enabled: enabledCount, disabled: disabledCount });
  };

  const displayLoading = (
    <div style={{ textAlign: "center" }}>
      <CircularProgress color="primary" thickness={7} />
    </div>
  );

  const displayError = (
    <Box
      style={{
        border: "2px solid rgb(255,0,0)",
        backgroundColor: "rgb(255,240,240)",
        Opacity: 1,
        textAlign: "center",
        padding: "0.8rem",
        fontSize: "0.875rem",
        marginBottom: "1.5em",
      }}
    >
      {" "}
      <Typography variant="body2">
        Something went wrong. Please try again later.
      </Typography>
    </Box>
  );

  const displayList = (
    <List className={classes.listContainer}>
      {screensAndFeatures?.map((screen) => (
        <React.Fragment key={screen.screen_id}>
          <ListItem
            button
            className={classes.screen}
            onClick={() => handleExpand(screen.screen_id)}
          >
            <ListItemIcon
              style={{
                visibility:
                  screen.features && screen.features.length > 0
                    ? "visible"
                    : "hidden",
              }}
            >
              {expandedSections[screen.screen_id] ? (
                <ExpandLess />
              ) : (
                <ExpandMore />
              )}
            </ListItemIcon>
            <ListItemText>{screen.screen_name}</ListItemText>
            <Switch
              classes={{ root: classes.root }}
              checked={screen.screen_access}
              onClick={(e) => e.stopPropagation()}
              onChange={() => handleToggleScreen(screen.screen_id)}
            />
          </ListItem>
          {screen.features && screen.features.length > 0 && (
            <Collapse
              in={expandedSections[screen.screen_id]}
              timeout="auto"
              unmountOnExit
            >
              <List>
                {screen?.features?.map((feature) => (
                  <ListItem
                    key={feature.feature_id}
                    button
                    className={classes.feature}
                  >
                    <ListItemText>{feature.feature}</ListItemText>
                    <Switch
                      classes={{ root: classes.root }}
                      checked={feature.feature_access}
                      onChange={() =>
                        handleToggleFeature(
                          screen.screen_id,
                          feature.feature_id
                        )
                      }
                      disabled={!screen.screen_access} // Disable feature toggle if screen access is off
                    />
                  </ListItem>
                ))}
              </List>
            </Collapse>
          )}
        </React.Fragment>
      ))}
    </List>
  );

  const displayNoRecordsFound = (
    <Box
      style={{
        display: "flex",
        justifyContent: "center", // Horizontally center the CircularProgress
        alignItems: "center", // Vertically center the CircularProgress
        height: "50px", // Optional: Set a height to vertically center the loader
        border: "2px solid #000",
        // backgroundColor: "#FFF0F0",
        width: "100%",
        marginTop: "20px",
      }}
    >
      <Typography style={{ textAlign: "center" }}>No records found</Typography>
    </Box>
  );

  return (
    <Box className={classes.container}>
      <Box className={classes.content}>
        <Typography style={{ fontSize: "16px", fontWeight: 500 }} gutterBottom>
          Access and Permissions
        </Typography>
        <Typography className={classes.heading}>
          Select a role from the below list, to pre-populate the Permissions to
          table:<span style={{ color: "red" }}>*</span>
        </Typography>
        <TextField
          size="small"
          select
          value={selectedRole}
          variant="outlined"
          className={classes.textField}
          onChange={handleRoleChange}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          SelectProps={{
            displayEmpty: true,
          }}
        >
          <MenuItem value="">Select a Role</MenuItem>
          {availableRoles?.map((role) => (
            <MenuItem key={role.value} value={role.value}>
              {role.label}
            </MenuItem>
          ))}
        </TextField>
        <Typography className={classes.resetText} onClick={handleReset}>
          Reset to Default
        </Typography>

        {loading
          ? displayLoading
          : error
            ? displayError
            : screensAndFeatures.length > 0
              ? displayList
              : selectedRole
                ? displayNoRecordsFound
                : ""}
      </Box>
      <Box className={classes.buttonContainer}>
        <Button
          variant="contained"
          onClick={handleBack}
          style={{ textTransform: "none" }}
        >
          Back
        </Button>
        <Button
          variant="contained"
          style={{
            backgroundColor:
              error !== null || selectedRole === "" ? "#cccccc" : "#286acf",
            color: error !== null || selectedRole === "" ? "#777777" : "white",
            textTransform: "none",
          }}
          onClick={handleCreate}
          disabled={error !== null || selectedRole === ""}
        >
          Create Role
        </Button>
      </Box>
    </Box>
  );
}
